import type { ReactNode } from 'react';

interface EmptyStateProps {
  title: string;
  body: string;
  action?: ReactNode;
}

export function EmptyState({ title, body, action }: EmptyStateProps) {
  return (
    <div style={{ textAlign: 'center', padding: '56px 24px', maxWidth: 480, margin: '0 auto' }}>
      <svg width="120" height="80" viewBox="0 0 120 80" fill="none" style={{ marginBottom: 20 }}>
        <rect x="14" y="18" width="38" height="54" stroke="var(--ink)" strokeWidth="1.2" fill="none" />
        <rect x="56" y="10" width="38" height="62" stroke="var(--ink)" strokeWidth="1.2" fill="none" />
        <line x1="22" y1="30" x2="44" y2="30" stroke="var(--ink)" strokeWidth="1" />
        <line x1="22" y1="38" x2="44" y2="38" stroke="var(--ink)" strokeWidth="1" />
        <line x1="64" y1="22" x2="86" y2="22" stroke="var(--ink)" strokeWidth="1" />
        <line x1="64" y1="30" x2="86" y2="30" stroke="var(--ink)" strokeWidth="1" />
        <line x1="64" y1="38" x2="86" y2="38" stroke="var(--ink)" strokeWidth="1" />
      </svg>
      <div className="serif" style={{ fontSize: 24, marginBottom: 10 }}>{title}</div>
      <div style={{ color: 'var(--stone)', marginBottom: 22 }}>{body}</div>
      {action}
    </div>
  );
}
